module.exports = __webpack_public_path__ + "static/media/zyman.beb487e9.webp";